<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kLyQjG/tc-custom/9781480484740.jpg?1698164814692" alt="This image is the cover for the book Traders"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Traders
      </h1>
      <p class="bookDescription body article font2">
        <b>An inside look at the high-stakes trading floors of major financial exchanges and the men and women who hold the chips</b><br/><br/>Sonny Kleinfield spent months with individual traders on five of America’s biggest financial exchanges. The investors he followed are the ultimate gamblers, trading only for themselves, not for clients, and sometimes going “all in” on stocks, options, and, ultimately, their own futures. These mavericks display a unique intensity and a savage brand of competitiveness. Acclaimed reporter Kleinfield gets inside their minds and worlds, showing what drives them to a stressful, high-stakes profession.<br/><br/>From the trading floors of the New York Stock Exchange, Chicago Board of Trade, Chicago Mercantile Exchange, Commodity Exchange Center, and American Stock Exchange, Kleinfield delivers a riveting portrait of a dying breed of go-for-broke entrepreneurs. Readers feel the frenzied excitement of the brokers and traders, and gain access to a risky, adrenaline-charged world where fortunes come and go in a single moment.<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sonny Kleinfield
      </h2>
      
      <p class="authorDescription body article">Sonny Kleinfield is a reporter for the <I>New York Times</I> and the author of eight books. He has contributed articles to the <I>Atlantic</I>, <I>Harper&rsquo;s Magazine</I>, <I>Esquire</I>, and <I>Rolling Stone</I>, and was a reporter for the <I>Wall Street Journal</I> before joining the <I>Times</I>. He shared in a Pulitzer Prize for a <I>Times</I> series on race in America, and has received a number of other accolades, including the Robert F. Kennedy Journalism Award, the Meyer Berger Award, an American Society of Newspaper Editors Award, and the Gerald Loeb Award. A native of Fair Lawn, New Jersey, he is a graduate of New York University and lives in New York City.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2c51963e